import React from 'react';
import { ArrowDown } from 'lucide-react';

export const Hero = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1707340733209-d8adf5ad25e6"
          alt="Caribou Studio Background"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-light text-white mb-6 tracking-tight animate-fade-in-up">
          MAKING DIGITAL
          <br />
          FEEL HUMAN
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl text-gray-200 font-light mb-12 max-w-3xl mx-auto animate-fade-in-up animation-delay-200">Built for brands that refuse to disappear into the scroll.

        </p>

        {/* CTA Button */}
        <button
          onClick={scrollToAbout}
          className="group inline-flex items-center space-x-2 text-white hover:text-gray-300 transition-colors duration-300 animate-fade-in-up animation-delay-400">

          <span className="text-sm tracking-wider">EXPLORE</span>
          <ArrowDown size={20} className="group-hover:translate-y-1 transition-transform duration-300" />
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>);

};